(function () {
    "use strict";

    angular.module("app").factory("settingsService", SettingsServiceFactory);

    SettingsServiceFactory.$inject = ['$rootScope', '$window','localStorageService'];
    function SettingsServiceFactory($rootScope, $window, localStorageService) {

        const store = this;

        const HasAlreadySeenPersonDisclaimer = 'HasAlreadySeenPersonDisclaimer';

        function configure(locale, path, app, timeoutError) {
            store.locale = locale;
            store.applicationPath = sanitizePath(path);
            store.appCodeName = app;
            store.sessionTimeoutError = timeoutError;

            $rootScope.sessionTimeoutError = store.timeoutError;
            $rootScope.applicationPath = store.applicationPath;
        }

        function sanitizePath(path) {
            if (path.substr(path.length - 1, 1) !== '/') {
                return path + '/';
            }

            return path;
        }

        store.Configure = configure;
        store.GetBaseUrl = () => `${$window.location.protocol}//${$window.location.host}${store.applicationPath}`;


        store.Properties = {
            get HasAlreadySeenPersonDisclaimer() { return localStorageService.getByKey(HasAlreadySeenPersonDisclaimer); },
            set HasAlreadySeenPersonDisclaimer(value) { localStorageService.setByKey(HasAlreadySeenPersonDisclaimer, value); }

            //add more properties
        };

        return store;
    }
})();